import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const BeautySolutionsConcerns = lazyWithPreload(
  () => import('./BeautySolutionsConcerns'),
)
